import React from 'react';
import { ApprovedImage } from 'assets/img';

interface Props {
  onClose?: () => void;
  userName?: string;
}

class ModalWelcome extends React.Component<Props> {
  render() {
    return (
      <div id='modal-welcome'>
        <div className='container-flex'>
          <div className='container-icon'>
            <img src={ApprovedImage} alt='Registro exitoso' />
          </div>
          <div style={{ flex: 1 }}>
            <h4>¡{this.props.userName}, tomaste la decisión correcta!</h4>
            <p style={{ marginBottom: 16 }}>
              Ahora tienes acceso a abogados reales que te van a escuchar y acompañar en lo que
              necesites.
            </p>
            <button
              className='btn-validate'
              style={{ backgroundColor: '#FB8C00' }}
              onClick={this.props.onClose}
            >
              Empezar a explorar
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalWelcome;
